export default __webpack_public_path__ + "static/media/ANCT_Logo-MC_transparent.399ff365.png";